import DocumentDownload from "../Entity/DocumentDownload";
import Document from "../Entity/Document";

export default class DocumentDownloadFactory {
    public create(
        resourceId: number,
        document: Document,
        sessionToken: string
    ): DocumentDownload {
        return new DocumentDownload(
            document.getIdInteger(),
            resourceId,
            document.getName(),
            document.getFilesize(),
            this.createUrl(document),
            document.getUuid(),
            document.getName(),
            document.getName(),
            document.getDescription(),
            document.getMimetype(),
            document.getIdInteger(),
            document.getUuid(),
            sessionToken,
            null,
            document.getEntityChanged(),
            0,
            document.getFormat(),
            document.getEntityBundle(),
            document.getTimeLapse(),
            document.getStatus(),
            document.getPosition()
        );
    }

    private createUrl(document: Document): string {
        return process.env.REACT_APP_BACKEND_MACHINE + "/media/" + document.getUuid() + "/download";
    }
}